<template>
  <v-container fluid class="pa-12" style="max-width: 1344px;">
    <v-row align="start" justify="center" class="px-12">
      <v-col cols="12">
        <v-card class="elevation-5">
          <v-data-table
            :headers="headers"
            :items="accounts"
            sort-by="id"
            class="elevation-1"
            :loading="loading"
            loading-text="Loading... Please wait"
            :search="search"
          >
            <template v-slot:top>
              <v-toolbar flat color="white">
                <v-toolbar-title>Account</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-text-field
                  v-model="search"
                  append-icon="search"
                  label="Search"
                  single-line
                  hide-details
                ></v-text-field>
                <v-spacer></v-spacer>
                <v-dialog v-model="dialog" max-width="500px">
                  <template v-slot:activator="{ on }">
                    <v-btn color="primary" dark class="mb-2" v-on="on"
                      >New Account</v-btn
                    >
                  </template>
                  <v-card>
                    <v-card-title>
                      <span class="headline">{{ formTitle }}</span>
                    </v-card-title>

                    <v-card-text>
                      <v-container>
                        <v-row>
                          <v-col cols="12" sm="6" md="6">
                            <v-text-field
                              v-model="editedItem.username"
                              label="Username"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="6" md="6">
                            <v-text-field
                              v-model="password"
                              label="Password"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="6" md="6">
                            <v-text-field
                              v-model="editedItem.email"
                              label="Email"
                            ></v-text-field>
                          </v-col>
                          <v-col class="d-flex" cols="12" sm="6">
                            <v-select
                              :items="permissionitems"
                              label="Permission"
                              item-text="permissionname"
                              item-value="permissionId"
                              v-model="editedItem.permissionname"
                            ></v-select>
                          </v-col>
                          <v-col cols="12" sm="6" md="6">
                            <v-select
                              :items="active"
                              label="Active"
                              v-model="editedItem.active"
                            ></v-select>
                          </v-col>
                          <v-col cols="12" sm="6" md="6">
                            <v-select
                              :items="reset"
                              label="Reset"
                              v-model="editedItem.reset"
                            ></v-select>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card-text>

                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="blue darken-1" text @click="close"
                        >Cancel</v-btn
                      >
                      <v-btn color="blue darken-1" text @click="save"
                        >Save</v-btn
                      >
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-toolbar>
            </template>
            <template v-slot:item.action="{ item }">
              <v-icon small class="mr-2" @click="resetPassword(item)"
                >lock</v-icon
              >
              <v-icon small class="mr-2" @click="editItem(item)">edit</v-icon>
              <!-- <v-icon small @click="deleteItem(item)">delete</v-icon> !-->
            </template>
            <template v-slot:no-data>
              <v-btn color="primary" @click="initialize">Reset</v-btn>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ApiService from '@/services/api.service'

export default {
  name: 'account',
  data: () => ({
    search: '',
    dialog: false,
    loading: true,
    headers: [
      { text: 'Account Id', value: 'id' },
      { text: 'USERNAME', value: 'username' },
      { text: 'EMAIL', value: 'email' },
      { text: 'PERMISSION', value: 'permissionname' },
      { text: 'ACTIVE', value: 'active' },
      { text: 'RESET', value: 'reset' },
      { text: 'Actions', value: 'action', sortable: false }
    ],
    permissionitems: [],
    accounts: [],
    editedIndex: -1,
    password: '',
    editedItem: {
      id: 0,
      username: '',
      email: '',
      permissionId: '',
      active: 0,
      reset: 0
    },
    defaultItem: {
      id: 0,
      username: '',
      email: '',
      permissionId: '',
      active: 0,
      reset: 0
    },
    active: [0, 1],
    reset: [0, 1]
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? 'New Account' : 'Edit Account'
    }
  },

  watch: {
    dialog(val) {
      val || this.close()
    }
  },

  created() {
    this.generatepermission()
    this.initialize()
  },

  methods: {
    generatepermission() {
      ApiService.get('/Permission')
        .then(res => {
          if (res.data.isauthenticated) {
            if (res.data.success) {
              this.permissionitems = res.data.respond
              this.loading = false
            } else {
              this.$swal('', res.data.error, 'error')
              this.loading = false
            }
          } else {
            this.loading = false
            return this.$router.push({ name: 'home' })
          }
        })
        .catch(() => {
          this.loading = false
        })
    },
    initialize() {
      this.submitBtnLoading = true
      ApiService.get('/Account')
        .then(res => {
          if (res.data.isauthenticated) {
            if (res.data.success) {
              this.accounts = res.data.respond
              this.loading = false
            } else {
              this.$swal('', res.data.error, 'error')
              this.loading = false
            }
          } else {
            this.loading = false
            return this.$router.push({ name: 'home' })
          }
        })
        .catch(() => {
          this.loading = false
        })
    },

    editItem(item) {
      this.editedIndex = this.accounts.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },
    resetPassword(item) {
      this.editedIndex = this.accounts.indexOf(item)
    },
    deleteItem(item) {
      const index = this.accounts.indexOf(item)
      confirm('Are you sure you want to delete this item?') &&
        this.accounts.splice(index, 1)
    },

    close() {
      this.password = ''
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },

    save() {
      if (this.editedIndex > -1) {
        let username = this.editedItem.username
        let email = this.editedItem.email
        let permissionname = this.editedItem.permissionname
        let active = this.editedItem.active
        let reset = this.editedItem.reset
        let AccountId = this.accounts[this.editedIndex].id

        let parent = this
        ApiService.put('/Account/' + AccountId, {
          username,
          email,
          permissionname,
          active,
          reset
        }).then(res => {
          if (res.data.success) {
            this.$swal('', res.data.respond, 'success').then(function() {
              parent.initialize()
              parent.btnLoading = false
            })
          } else {
            this.btnLoading = false
            this.$swal('', res.data.error, 'error')
          }
        })
        Object.assign(this.accounts[this.editedIndex], this.editedItem)
      } else {
        let username = this.editedItem.username
        let password = this.password
        let email = this.editedItem.email
        let permissionname = this.editedItem.permissionname
        let active = this.editedItem.active
        let reset = this.editedItem.reset
        let parent = this
        ApiService.post('/Account', {
          username,
          password,
          email,
          permissionname,
          active,
          reset
        }).then(res => {
          if (res.data.success) {
            this.$swal('', res.data.respond, 'success').then(function() {
              parent.initialize()
              parent.btnLoading = false
            })
          } else {
            this.btnLoading = false
            this.$swal('', res.data.error, 'error')
          }
        })
      }
      this.close()
    }
  }
}
</script>
